module.exports = __webpack_public_path__ + "media/images/circle_14025226-c0e26c593c6e180c193a24b5a72e561a.png";